/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReviewPalAuthSubmissionRequest
 */
export interface ReviewPalAuthSubmissionRequest {
    /**
     * Payor ID (required for automated review)
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    payor_id?: string;
    /**
     * Auth platform ID (required for automated review)
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    auth_platform_id?: string;
    /**
     * Whether this is a non-submission flow
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    is_non_submission_flow?: boolean;
    /**
     * Optional override for review mode. 'efax' prepares the PAL submission for fax delivery without selecting a payer portal form.
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    submission_mode?: ReviewPalAuthSubmissionRequestSubmissionModeEnum;
    /**
     * Required when submission_mode is efax. Normalized destination fax number to persist on the PAL submission during review.
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    destination_fax_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
}


/**
 * @export
 */
export const ReviewPalAuthSubmissionRequestSubmissionModeEnum = {
    Efax: 'efax'
} as const;
export type ReviewPalAuthSubmissionRequestSubmissionModeEnum = typeof ReviewPalAuthSubmissionRequestSubmissionModeEnum[keyof typeof ReviewPalAuthSubmissionRequestSubmissionModeEnum];


/**
 * Check if a given object implements the ReviewPalAuthSubmissionRequest interface.
 */
export function instanceOfReviewPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewPalAuthSubmissionRequestFromJSON(json: any): ReviewPalAuthSubmissionRequest {
    return ReviewPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function ReviewPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor_id': !exists(json, 'payor_id') ? undefined : json['payor_id'],
        'auth_platform_id': !exists(json, 'auth_platform_id') ? undefined : json['auth_platform_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
        'submission_mode': !exists(json, 'submission_mode') ? undefined : json['submission_mode'],
        'destination_fax_number': !exists(json, 'destination_fax_number') ? undefined : json['destination_fax_number'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
    };
}

export function ReviewPalAuthSubmissionRequestToJSON(value?: ReviewPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor_id': value.payor_id,
        'auth_platform_id': value.auth_platform_id,
        'is_non_submission_flow': value.is_non_submission_flow,
        'submission_mode': value.submission_mode,
        'destination_fax_number': value.destination_fax_number,
        'include_lead_summary_report': value.include_lead_summary_report,
    };
}

